// ========================================
// CHALLENGE CONFIGURATION
// Update this file to change daily/weekly challenges
// ========================================

export interface ChallengeConfig {
    type: 'daily' | 'weekly';
    title: string;
    prompt: string;
    wordTarget: number;
    xpReward: number;
    icon: string;
    color: string;
    borderColor: string;
    description: string
  }
  
  // ========================================
  // 🔥 DAILY CHALLENGE
  // Updates every day at midnight
  // ========================================
  export const dailyChallenge: ChallengeConfig = {
    type: 'daily',
    title: 'Quick Write',
    description: 'Write 500 words today',
    prompt: 'Write about your favorite place to visit.',
    wordTarget: 500,
    xpReward: 50,
    icon: '⏰',
    color: '#FEF3C7',      // Light yellow
    borderColor: '#F59E0B'  // Orange
  };
  
  // ========================================
  // 📚 WEEKLY CHALLENGE
  // Updates every Monday at midnight
  // ========================================
  export const weeklyChallenge: ChallengeConfig = {
    type: 'weekly',
    title: 'Mystery Story Challenge',
    description: 'Write a 1,500 word mystery story',
    prompt: 'Something strange happened at school today. When I opened my locker, I found...',
    wordTarget: 1500,
    xpReward: 200,
    icon: '🔍',
    color: '#EDE9FE',      // Light purple
    borderColor: '#6C5CE7'  // Purple
  };
  
  // ========================================
  // 🎲 CHALLENGE ROTATION
  // Array of prompts to rotate through
  // ========================================
  
  export const dailyPrompts = [
    'Write about your favorite place to visit.',
    'Describe a perfect day from start to finish.',
    'Write about a time you learned something new.',
    'Imagine you found a magic door. What\'s behind it?',
    'Write about your favorite food and why you love it.',
    'Describe your dream treehouse or fort.',
    'Write about an adventure with your best friend.'
  ];
  
  export const weeklyPrompts = [
    'Something strange happened at school today. When I opened my locker, I found...',
    'You discover you can talk to animals for one day. What happens?',
    'Write a story where the main character has to solve a mystery.',
    'You wake up and everything is backwards. Describe your day.',
    'A new kid at school has an incredible secret. What is it?',
    'You find an old map in your attic. Where does it lead?',
    'Write a story about a character who can freeze time.'
  ];
  
  // ========================================
  // 📅 HELPER FUNCTIONS
  // ========================================
  
  /**
   * Get current day's prompt (rotates daily)
   */
  export const getTodaysDailyPrompt = (): string => {
    const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
    const index = dayOfYear % dailyPrompts.length;
    return dailyPrompts[index];
  };
  
  /**
   * Get current week's prompt (rotates weekly)
   */
  export const getThisWeeksPrompt = (): string => {
    const weekOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 1).getTime()) / 604800000);
    const index = weekOfYear % weeklyPrompts.length;
    return weeklyPrompts[index];
  };
  
  /**
   * Get active daily challenge with rotated prompt
   */
  export const getActiveDailyChallenge = (): ChallengeConfig => {
    return {
      ...dailyChallenge,
      prompt: getTodaysDailyPrompt()
    };
  };
  
  /**
   * Get active weekly challenge with rotated prompt
   */
  export const getActiveWeeklyChallenge = (): ChallengeConfig => {
    return {
      ...weeklyChallenge,
      prompt: getThisWeeksPrompt()
    };
  };
  
  // ========================================
  // 🎨 THEME CONFIGURATION
  // ========================================
  
  export const challengeTheme = {
    daily: {
      background: '#FEF3C7',
      border: '#F59E0B',
      text: '#92400E',
      icon: '⏰'
    },
    weekly: {
      background: '#EDE9FE',
      border: '#6C5CE7',
      text: '#4C1D95',
      icon: '📚'
    }
  };